<template>
    <div>
        <resource-form :endpoint="endpoint" :method="method" :rules="rules" :schema="schema" :model="permissionModel"
                       @close="permissionModel = {}">
            <template #title>{{'page.roles.new_permission' | trans}}</template>
            <template #button>{{'page.roles.new_permission' | trans}}</template>
            <template #form="{ resource }">
                <v-flex xs12>
                    <v-text-field v-model="resource.name"
                                  :rules="rules.name"
                                  required
                                  :label="'app.name' | trans"
                    ></v-text-field>
                </v-flex>
            </template>
        </resource-form>
    </div>
</template>

<script>
  import { trans } from '../../../app';
  import has from 'lodash/has';

  export default {
    props: {
      model: Object,
    },
    data: () => ({
      permissionModel: null,
      schema: {
        name: null,
      },
      nameError: [],
      rules: {
        name: [
          v => !!v || trans('validation.required', { 'attribute': trans('app.name') }),
          v => v && v.length <= 255 || trans('validation.max.string', {
            attribute: trans('app.name'),
            max: 255,
          }),
          v => v && v.length >= 3 || trans('validation.min.string', {
            attribute: trans('app.name'),
            min: 3,
          }),
        ],
      },
    }),
    watch: {
      model(val) {
        this.permissionModel = val;
      },
    },

    computed: {
      method() {
        return has(this.model, 'id') ? 'PATCH' : 'POST';
      },
      endpoint() {
        if (has(this.model, 'id')) {
          return `/administrator/permissions/${this.model.id}`;
        }

        return '/administrator/permissions';
      },
    },
  }
  ;
</script>
